import { VideoCategory } from '../../../core/interfaces/video-category';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Meeting } from 'src/app/core/interfaces/meeting';
import { Component, DestroyRef, ElementRef, inject, Inject, Optional, ViewChild } from '@angular/core';
import { FrameVimeoLiveComponent } from '../../components/frame-vimeo-live/frame-vimeo-live.component';
import { ElapsedTimeService } from '../../../core/elapsed-time-service/elapsed-time.service';
import { ANALYTICS_PROVIDER } from '@futura/futura-ui';

@Component({
  selector: 'app-view-live-recording-dialog',
  templateUrl: './view-live-recording-dialog.component.html',
  styleUrls: ['./view-live-recording-dialog.component.scss'],
  standalone: true,
  imports: [FrameVimeoLiveComponent],
})
export class ViewLiveRecordingDialogComponent {
  private readonly destroyRef = inject(DestroyRef);
  private readonly analyticsService = inject(ANALYTICS_PROVIDER);
  private readonly elapsedTimeService = inject(ElapsedTimeService);
  @ViewChild('videoFrame', { read: ElementRef }) private videoFrame?: ElementRef;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { live?: Meeting; video?: VideoCategory },
    @Optional() private dialogRef: MatDialogRef<ViewLiveRecordingDialogComponent>
  ) {
    this.destroyRef.onDestroy(() => {
      const elapsedArchiveTime = this.elapsedTimeService.stop('action_video_complete#archive');
      if (elapsedArchiveTime) {
        let title = '';
        let video_id = '';

        if (data?.live) {
          title = data?.live.content.title || '';
          video_id = data?.live.instance_id;
        }
        if (data?.video) {
          title = data?.video.video_title || '';
          video_id = data?.video.video_uuid;
        }

        this.analyticsService?.sendAnalytics({
          eventName: 'action_video_complete',
          eventParams: {
            title,
            video_id,
            type: 'archive',
            elapsed_time: elapsedArchiveTime,
          },
        });
      }
    });
  }

  public onClickElement(event: MouseEvent): void {
    const contains = this.videoFrame?.nativeElement?.contains(event.target);
    if (contains) {
      return;
    }
    this.dialogRef?.close();
  }
}
